module.exports = __webpack_public_path__ + "static/media/member6.aab99d7f.png";